export enum AccountType {
    Guest = "guest",
    Family = "family",
    Main = "main",
}
